// extracted by mini-css-extract-plugin
export default {"gameCommentary":"GameCommentary_gameCommentary__Ty7Ah","winnerName":"GameCommentary_winnerName__kmm5V","mediaLink":"GameCommentary_mediaLink__kBZqA"};